import el from '@finn-no/create-element';

const showFullText = element => {
    element.style.maxHeight = 'none';
};

const showExpandButton = element => {
    const expandId = `${element.id}_expand`;

    const expandButton = el(
        'div.pt-8',
        {
            id: expandId,
        },
        el(
            'button.button.button--link',
            {
                onclick: () => expandedText(element),
            },
            el('p.font-bold.mb-0', {}, '+ Vis hele beskrivelsen')
        )
    );
    element.parentNode.insertBefore(expandButton, element.nextSibling);
};

const removeExpandButton = element => {
    const expandId = `${element.id}_expand`;
    const expandButton = document.getElementById(expandId);
    expandButton.parentNode.removeChild(expandButton);
};

const removeCollapseButton = element => {
    const collapseId = `${element.id}_collapse`;
    const collapseButton = document.getElementById(collapseId);
    collapseButton.parentNode.removeChild(collapseButton);
};

const collapseText = element => {
    element.style.maxHeight = `${element.getAttribute('data-max-height')}px`;
    removeCollapseButton(element);
    showExpandButton(element);
};

const showCollapseButton = element => {
    const collapseId = `${element.id}_collapse`;
    const collapseButton = el(
        'button.button.button--link.mt-16',
        {
            id: collapseId,
            onclick: () => collapseText(element),
        },
        el('p.font-bold.mb-0', {}, '- Vis mindre')
    );
    element.parentNode.insertBefore(collapseButton, element.nextSibling);
};

const expandedText = element => {
    showFullText(element);
    removeExpandButton(element);
    showCollapseButton(element);
};

export const initDescriptionExpansionBasedOnContentHeight = textContentRef => {
    const element = textContentRef.current;
    textContentRef.current.id = 'collapsableTextContent';
    const currentHeight = element.clientHeight;
    const potentialMaxHeight = element.scrollHeight;

    if (potentialMaxHeight > currentHeight) {
        if (potentialMaxHeight - currentHeight < 50) {
            showFullText(element);
        } else {
            showExpandButton(element);
        }
    }
};
